import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["titleWidth", "children"];
import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { getLength } from 'utils/ui';
var DescriptionListWrapper = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'titleWidth';
  }
}).withConfig({
  displayName: "DescriptionList__DescriptionListWrapper",
  componentId: "sc-114a8gy-0"
})(["display:grid;grid-template-columns:fit-content(", ") minmax( 0,1fr );justify-items:start;gap:", " ", ";"], function (p) {
  return getLength(p.titleWidth);
}, function (p) {
  return p.theme.globals.spacing.xxs;
}, function (p) {
  return p.theme.globals.spacing.s;
});
export default function DescriptionList(_ref) {
  var _ref$titleWidth = _ref.titleWidth,
    titleWidth = _ref$titleWidth === void 0 ? '50%' : _ref$titleWidth,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DescriptionListWrapper, _extends({
    titleWidth: titleWidth
  }, otherProps, {
    as: "dl"
  }), children);
}